import { translate } from "app/filters/i18nFilter";
import type {
    GraphDataWithZones,
    ITransformedDataPoint,
} from "app/pages/keyword-research/website-analysis/pages/website-keywords/table/clicks-over-time-graph/types";

const getTotalClicksLabel = () => translate("keywordanalysis.organic2.clicks.over.time.total.clicks");

export const calculateTotals = ({
                                    graphData,
                                    containsPartialWeek,
                                }: {
    graphData: GraphDataWithZones;
    containsPartialWeek: boolean;
}): ITransformedDataPoint | object => {
    if (!graphData.length) {
        return {};
    }
    const name = getTotalClicksLabel();
    // Assume all series have the same x's in the same order
    const dataLength = graphData[0].data.length;
    const data = Array.from({ length: dataLength }, (_, idx) => {
        const x = graphData[0].data[idx].x;
        const y = graphData.reduce((sum, series) => sum + (series.data[idx]?.y ?? 0), 0);
        const isPartial = idx === dataLength - 1 ? containsPartialWeek : false;
        return { x, y, isPartial, shareValue: 0 };
    });
    return {
        name,
        id: name,
        data,
        marker: { symbol: "circle" },
        color: graphData[0].color,
        // This total is only used for displaying data on each graph point in the tooltip
        visible: false,
        isTotal: true,
        zones: [],
        total: 0,
    };
};
